import React from 'react';
import { ABOUT_US_IMAGES } from '../utils/imageUrls';

function AboutUs() {
    return (
        <div className="py-10 bg-surface" dir="rtl">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">

                    {/* אזור הטקסט - העתק מדויק של התוכן שלך באריזה יוקרתית */}
                    <div className="order-2 lg:order-1 flex flex-col justify-center">
                        <h2 className="text-sm font-bold tracking-widest text-accent uppercase mb-4">
                            מי אנחנו
                        </h2>
                        <h1 className="text-3xl sm:text-4xl md:text-5xl font-medium text-text-primary mb-8 leading-tight">
                            אודותינו
                        </h1>

                        <div className="w-16 h-1 bg-accent mb-10 rounded-full"></div>

                        <div className="space-y-6 text-base sm:text-lg text-text-secondary font-light leading-relaxed">
                            <p>
                                ברוכים הבאים לPuma! אנחנו חברה שמתמחה בפתרונות ריהוט לבית ולגן,
                                עם דגש על איכות, עיצוב וחדשנות. המוצרים שלנו מיוצרים מהחומרים הטובים ביותר
                                וכוללים מגוון רחב של פרויקטים ייחודיים המותאמים לצרכי הלקוחות שלנו.
                            </p>
                            <p>
                                אנו מתחייבים להעניק שירות מעולה וחוויית קנייה בלתי נשכחת.
                                אנחנו תמיד כאן כדי לסייע לכם לבחור את הרהיטים המתאימים ביותר לביתכם או לגינתכם.
                                בואו להתרשם ממבחר הפרויקטים שלנו וליהנות מריהוט איכותי ומעוצב!
                            </p>
                        </div>
                    </div>

                    {/* אזור התמונה (תמונת הערסל שלך) - מסגור אדריכלי נקי */}
                    <div className="order-1 lg:order-2 relative">
                        <div className="aspect-[4/3] lg:aspect-[4/5] rounded-2xl overflow-hidden shadow-hover relative z-10 border border-secondary/50">
                            <img
                                src={ABOUT_US_IMAGES.companyImage}
                                alt="תמונה של ערסל נדנדה"
                                className="w-full h-full object-cover transition-transform duration-1000 hover:scale-105"
                            />
                        </div>
                        {/* אלמנט דקורטיבי שמוסיף עומק (ריבוע רקע שזז הצידה) */}
                        <div className="hidden sm:block absolute -bottom-6 -left-6 w-full h-full bg-background rounded-2xl z-0 border border-secondary-dark/30"></div>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default AboutUs;